import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';

import {ActivityFeedTimeStamp} from './ActivityFeedTimeStamp';
import {useGetUrlContextSegment} from "../../../Hooks/RouteHooks";
import {ActivityFeedValueDeltaDisplay} from "./ActivityFeedValueDeltaDisplay";

export const ActivityFeedItem = props => {
    const getUrlContextSegment = useGetUrlContextSegment();

    const [customData, setCustomData] = useState({});

    const {
        title: ActivityTitleComponent,
        description,
        rightSection,
        Event: contextNodeActivity = {}
    } = props;
    const {
        Activity: activity = null,
        ContextNodeDetails: contextNodeDetails = null
    } = contextNodeActivity;

    useEffect(() => {
        let data = activity?.data;
        if (typeof data === 'string' || data instanceof String) {
            data = JSON.parse(data);
        }
        setCustomData(data);
    }, [JSON.stringify(contextNodeActivity)]);

    const getPhrase = () => {
        if(!(customData?.newValue ?? "")) {
            return "removed";
        } else if(!(customData?.oldValue ?? "")) {
            return "added";
        } else {
            return "updated";
        }
    }

    const getTitleLinkProps = () => {
        if (contextNodeActivity) {
            return {
                Context: contextNodeDetails.link
            }
        }
        return null
    }

    const renderSecondaryDescription = () => {
        // use provided
        if(rightSection) {
            return <props.rightSection CustomEventData={customData} Event={contextNodeActivity} />
        }

        // default if we have deltas
        if(customData.newValue !== undefined
            && customData.oldValue !== undefined
            && customData.viewer != null
        ) {
            return <ActivityFeedValueDeltaDisplay
                NewValue={customData.newValue}
                OldValue={customData.oldValue}
                NewData={customData.newData}
                OldData={customData.oldData}
                FieldCustomData={customData.fieldCustomData}
                Viewer={customData.viewer}
            />;
        }

        return null;

    }

    const renderTitle = () => {
        return <h4 className="sb-activity-feed-group-item-summary-title">
            <ActivityTitleComponent {...{contextNodeActivity}} />
        </h4>;
    }

    const renderDescription = () => {
        if(description != null) {
            return <props.description CustomEventData={customData} Event={contextNodeActivity} GetPhrase={getPhrase} />
        }
        return null
    }

    const renderTimeStamp = () => {
        return <ActivityFeedTimeStamp Event={contextNodeActivity} />
    }


    let secondaryDescription = renderSecondaryDescription();

    if(secondaryDescription != null) {
        return <Row className="sb-activity-feed-group-item">
            <Col xs={8} className="sb-activity-feed-group-item-summary">
                {renderTitle()}
                {renderDescription()}
                {renderTimeStamp()}
            </Col>
            <Col xs={4} className="sb-activity-feed-group-item-view">
                {secondaryDescription}
            </Col>
        </Row>
    }

    return <Row className="sb-activity-feed-group-item">
        <Col xs={12} className="sb-activity-feed-group-item-summary">
            {renderTitle()}
            {renderDescription()}
            {renderTimeStamp()}
        </Col>
    </Row>;

}



